export enum ConferenceLinkType {
  OTHER = "other",
  GOOGLE = "google",
  MICROSOFT = "microsoft",
  MICROSOFT_STANDALONE = "microsoftStandalone",
}
